export const TOKEN_PARAM = 't';
export const TOKEN_ATTRIBUTE = 'custom:invitation_token';
export const CLIENT_ATTRIBUTE = 'custom:client_id';
export const PREVENT_SIGNUP_ERROR_CODE = 'UserLambdaValidationException';
